import { Injectable } from '@angular/core';
import { GlobalException } from './global-exception';

@Injectable()
export class Globals {
  exception: GlobalException;
}
